import { Routes } from '@angular/router';
export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/staff/auth/page/auth-page/auth-page.component').then(c => c.AuthPageComponent),
    title: 'FBS Live',
  },
  { path: 'admin', redirectTo: 'login', pathMatch: 'full' },
  { path: 'manager', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'staff',
    loadChildren: () => import('./features/staff/staff.routes').then(r => r.staffRoutes),
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' },
];
